import React from 'react';
import ReactDOM from 'react-dom';
import { PriceRange } from 'components';
import { logger } from 'packages';
import Messaging from 'packages/react/messaging';
import InitData from 'core/script/app/data/init-data';

const getPriceRangeParams = searchParams => {
    if (searchParams) {
        try {
            const params = JSON.parse(searchParams);
            return {
                fromPrice: params.fromPrice || 1,
                toPrice: params.toPrice || 5000
            };
        } catch (e) {
            logger(e);
        }
    }
    return null;
};

export default (elementsToAttachTo, options = {}) => {
    const initData = InitData.current();
    const priceRangeParams = getPriceRangeParams(initData.searchParams);
    if (!elementsToAttachTo || !priceRangeParams) {
        return;
    }
    $(document).ready(function() {
        try {
            const sliderElementsAsArray = Array.from(elementsToAttachTo);
            const messages = new Messaging();

            sliderElementsAsArray.map(sliderElement => {
                ReactDOM.render(
                    <PriceRange
                        rangeStart={1}
                        rangeEnd={5000}
                        handleStart={priceRangeParams['fromPrice']}
                        handleEnd={priceRangeParams['toPrice']}
                        searchResults={sliderElement.dataset.options}
                        navigateEvent={options.navigateEvent || 'ui:navigate'}
                    />,
                    sliderElement
                );
                messages.subscribe(
                    [
                        'data:navigation:after-page-load',
                        'data:navigation-filter:after-load'
                    ],
                    function() {
                        ReactDOM.unmountComponentAtNode(sliderElement);
                        messages.teardown();
                    }
                );
            });
        } catch (e) {
            logger(e);
        }
    });
};
